import './BottomShadowOverlay.css';
import React from 'react';
var BottomShadowOverlay = function BottomShadowOverlay(_ref) {
  var children = _ref.children,
    onClick = _ref.onClick;
  return /*#__PURE__*/React.createElement("div", {
    className: commonStyles,
    onClick: onClick
  }, /*#__PURE__*/React.createElement("div", {
    onClick: function onClick(ev) {
      return ev.stopPropagation();
    }
  }, children));
};
export default BottomShadowOverlay;
export var commonStyles = "cnr11eu";